<div class="sentiment-details-trend">
  <div class="sentiment-details-trend__body" *ngIf="loading">
    <p class="sentiment-details-trend__loading">Loading trend...</p>
  </div>
  <div class="sentiment-details-trend__chart" *ngIf="!loading && trendData.length">
    <div
      *ngFor="let d of trendData; let i = index"
      class="sentiment-details-trend__bar-row"
    >
      <span class="sentiment-details-trend__label">{{ displayPeriod(d.period, i) }}</span>
      <div class="sentiment-details-trend__bar-wrap">
        <div
          class="sentiment-details-trend__bar"
          [style.width.%]="(d.count / maxCount) * 100"
        ></div>
      </div>
      <span class="sentiment-details-trend__count">{{ d.count | number }}</span>
    </div>
  </div>
  <div class="sentiment-details-trend__empty" *ngIf="!loading && !trendData.length">
    <p>No trend data</p>
  </div>
</div>
